// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2qz9K","notes":"Notes_notes__3VMi3"};